import React from 'react';
import {VideoEditorText} from '../VideoEditorText';
import FilterPill from '../../../uiToolkit/FilterPill';
import {useEditMediaState} from './useEditMediaState';
import {MediaSourceId} from './editMediaTypes';
import EditMediaLibrarySource from './EditMediaLibrarySource';
import EditMediaStoryblocksSource from './EditMediaStoryblocksSource';
import styles from './EditMediaBrowserPanel.module.css';

interface Props {
  state: ReturnType<typeof useEditMediaState>;
  organizationId: string;
  chunkId: string;
  disabled?: boolean;
}

const SOURCE_TABS: {
  id: MediaSourceId;
  labelKey: keyof typeof VideoEditorText;
  icon: string;
}[] = [
  {id: 'library', labelKey: 'editMediaTabLibrary', icon: 'tab-library.svg'},
  {
    id: 'storyblocks',
    labelKey: 'editMediaTabStoryblocks',
    icon: 'tab-storyblocks.svg',
  },
];

const EditMediaBrowserPanel = React.memo(
  ({state, organizationId, chunkId, disabled = false}: Props) => {
    const onSourceChange = (id: MediaSourceId) => {
      state.setActiveSource(id);
      state.setPending(null);
    };

    return (
      <div className={styles.container}>
        <div className={styles.tabs}>
          {SOURCE_TABS.map(tab => (
            <FilterPill
              key={tab.id}
              id={tab.id}
              icon={tab.icon}
              title={VideoEditorText[tab.labelKey]}
              selected={state.activeSource === tab.id}
              onSelect={onSourceChange}
            />
          ))}
        </div>

        {state.activeSource === 'library' && (
          <EditMediaLibrarySource
            organizationId={organizationId}
            pending={state.pending}
            onPick={state.setPending}
            disabled={disabled}
          />
        )}
        {state.activeSource === 'storyblocks' && (
          <EditMediaStoryblocksSource
            organizationId={organizationId}
            chunkId={chunkId}
            pending={state.pending}
            onPick={state.setPending}
            disabled={disabled}
          />
        )}
      </div>
    );
  },
);

export default EditMediaBrowserPanel;
